import styled from 'styled-components'
import { NavLink } from '../../../commons/link'

export const StyledMobileMenu = styled.div`
  border-top: 1px solid #ddd;
  border-right: 1px solid #ddd;
  max-width: 320px;
  width: 100%;
  position:fixed;
  background: white;
  left: 0;
  top: 70px;
  transform: ${({ $open }) => $open ? 'translateX(0)' : 'translateX(-100%)'};
  transition: transform .3s ease-out;
  padding: 15px;
  height: calc(100vh - 70px);
  overflow: hidden;
`

const menuLinkStyles = `
  font-size: 18px;
  width: 100%;
  display: inline-block;
  padding: 8px 0;
  &:hover {
    color: #ff3700;
  }
  &:not([href]):after {
    content: "\f054";
    font-weight: 700;
    font-family: 'Font Awesome 5 Free';
    margin-left: 8px;
    margin-top: -3px;
    vertical-align: initial;
    font-size: 80%;
    display: inline-block;
    -webkit-backface-visibility: hidden;
  }
`

export const StyledMobileMenuLink = styled(NavLink)`
  ${menuLinkStyles}
  &[data-theme="public-spaces"] {
    font-weight: 700;
    color: #1e9d8b;
  }

  & > span {
    margin-left:4px;
    font-size: 80%;
    font-weight: 400;
    color: rgb(128, 128, 128);
  }
`

export const StyledMobileMenuItem = styled.div`
  cursor: pointer;
  ${menuLinkStyles}
`

export const StyledMobileBackButton = styled.div`
  font-size: 16px;
  cursor: pointer;
  width: 100%;
  display: inline-block;
  padding: 8px 15px;
  margin: 15px 0;
  &:hover {
    color: #ff3700;
  }
  &:before {
    content: "\f053";
    font-weight: 700;
    font-family: 'Font Awesome 5 Free';
    margin-right: 8px;
    margin-top: -3px;
    vertical-align: initial;
    font-size: 70%;
    display: inline-block;
    -webkit-backface-visibility: hidden;
  }
`

export const StyledMobileMenuTitle = styled.div`
  background: #eee;
  width: 100%;
  padding: 12px;
  text-align: center;
  font-weight: 700;
  margin-bottom: 15px;
`

export const StyledMobileSubMenuPanel = styled.div`
  background: white;
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  left: ${({ $open }) => $open ? '0' : '100%'};
  z-index: ${({ $open }) => $open ? '10' : '0'};
  transition: left .3s ease-out;
  & > ul {
    padding: 0 15px;
  }
`
export const StyledMobileMenuPosterList = styled.ul`
  margin-top: 25px;
  display: none;
`
